import 'ng-wig';
import textEditorDirective from './textEditor.directive';
import textEditorConfig from './textEditor.config';
import { LANGUAGES } from '../../app.constants';
import { EDITOR_ID } from './textEditor.constants';

angular
    .module('rym.textEditor', ['ngWig'])
    .config(textEditorConfig)
    .directive('rymTextEditor', textEditorDirective)
    .component('nwBtnBold', {
        template: `<button class="nw-button {{::$ctrl.buttonStyle}}" title="{{::$ctrl.title}}" ng-class="{ 'nw-button--active': $ctrl.isActive() }" ng-click="::$ctrl.click()"></button>`,
        controller: [
            'translationService',
            '$scope',
            '$rootScope',
            'eventEmitterService',
            function (translationService, $scope, $rootScope, eventEmitterService) {
                this.translationService = translationService;
                this.eventEmitterService = eventEmitterService;
                this.$scope = $scope;
                this.format = 'bold';

                let commandTip = $rootScope.isMACOS ? '(⌘Cmd+B)' : '(Ctrl+B)';
                this.title = `${this.translationService.translate('client_ButtonBold')} ${commandTip}`;

                this.$onInit = () => {
                    const lang = this.translationService.preferredLanguage();
                    if (lang && (lang === LANGUAGES.SWEDISH_CODE || lang === LANGUAGES.NORWEGIAN_CODE)) {
                        this.buttonStyle = 'fet';
                    } else {
                        this.buttonStyle = this.format;
                    }

                    this.eventEmitterService.subscribe('text-editor:focusChanged', (hasFocus) => {
                        this.textEditorHasFocus = hasFocus;
                    });
                };

                this.click = () => {
                    this.$scope.$parent.$ctrl.execCommand(this.format);
                };

                this.isActive = () => {
                    if (!this.textEditorHasFocus) {
                        return false;
                    }
                    let currentNode = window.getSelection().focusNode;
                    if (currentNode) {
                        while (currentNode.id !== EDITOR_ID) {
                            if (currentNode.tagName === 'B') {
                                return true;
                            }
                            currentNode = currentNode.parentNode;
                        }
                        return false;
                    }
                };
            }
        ]
    })
    .component('nwBtnItalic', {
        template: `<button class="nw-button {{::$ctrl.buttonStyle}}" title="{{::$ctrl.title}}" ng-class="{ 'nw-button--active': $ctrl.isActive() }" ng-click="::$ctrl.click($event)"></button>`,
        controller: [
            'translationService',
            '$scope',
            '$rootScope',
            'eventEmitterService',
            function (translationService, $scope, $rootScope, eventEmitterService) {
                this.translationService = translationService;
                this.eventEmitterService = eventEmitterService;
                this.$scope = $scope;
                this.format = 'italic';
                let commandTip = $rootScope.isMACOS ? '(⌘Cmd+I)' : '(Ctrl+I)';
                this.title = `${this.translationService.translate('client_ButtonItalic')} ${commandTip}`;
                this.$onInit = () => {
                    const lang = this.translationService.preferredLanguage();
                    if (lang && (lang === LANGUAGES.SWEDISH_CODE || lang === LANGUAGES.NORWEGIAN_CODE)) {
                        this.buttonStyle = 'kursiv';
                    } else {
                        this.buttonStyle = this.format;
                    }

                    this.eventEmitterService.subscribe('text-editor:focusChanged', (hasFocus) => {
                        this.textEditorHasFocus = hasFocus;
                    });
                };

                this.click = () => {
                    this.$scope.$parent.$ctrl.execCommand(this.format);
                };

                this.isActive = () => {
                    if (!this.textEditorHasFocus) {
                        return false;
                    }

                    let currentNode = window.getSelection().focusNode;
                    if (currentNode) {
                        while (currentNode.id !== EDITOR_ID) {
                            if (currentNode.tagName === 'I') {
                                return true;
                            }
                            currentNode = currentNode.parentNode;
                        }
                        return false;
                    }
                };
            }
        ]
    })
    .component('nwBtnUnderline', {
        template: `<button class="nw-button underline" title="{{::$ctrl.title}}" ng-class="{ 'nw-button--active': $ctrl.isActive() }" ng-click="::$ctrl.click()"></button>`,
        controller: [
            'translationService',
            '$scope',
            '$rootScope',
            'eventEmitterService',
            function (translationService, $scope, $rootScope, eventEmitterService) {
                this.translationService = translationService;
                this.eventEmitterService = eventEmitterService;
                this.$scope = $scope;
                this.format = 'underline';

                this.$onInit = () => {
                    this.eventEmitterService.subscribe('text-editor:focusChanged', (hasFocus) => {
                        this.textEditorHasFocus = hasFocus;
                    });
                };
                let commandTip = $rootScope.isMACOS ? '(⌘Cmd+U)' : '(Ctrl+U)';
                this.title = `${this.translationService.translate('client_ButtonUnderlined')} ${commandTip}`;

                this.click = () => {
                    this.$scope.$parent.$ctrl.execCommand(this.format);
                };

                this.isActive = () => {
                    if (!this.textEditorHasFocus) {
                        return false;
                    }

                    let currentNode = window.getSelection().focusNode;
                    if (currentNode) {
                        while (currentNode.id !== EDITOR_ID) {
                            if (currentNode.tagName === 'U') {
                                return true;
                            }
                            currentNode = currentNode.parentNode;
                        }
                        return false;
                    }
                };
            }
        ]
    })
    .component('nwBtnBullet', {
        template: `<button class="nw-button list-ul" title="{{::$ctrl.translationService.translate('client_ButtonBulletedList')}}" ng-class="{ 'nw-button--active': $ctrl.isActive() }" ng-click="::$ctrl.click()"></button>`,
        controller: [
            'translationService',
            '$scope',
            'eventEmitterService',
            function (translationService, $scope, eventEmitterService) {
                this.translationService = translationService;
                this.eventEmitterService = eventEmitterService;
                this.$scope = $scope;
                this.format = 'insertunorderedlist';

                this.$onInit = () => {
                    this.eventEmitterService.subscribe('text-editor:focusChanged', (hasFocus) => {
                        this.textEditorHasFocus = hasFocus;
                    });
                };

                this.click = () => {
                    this.$scope.$parent.$ctrl.execCommand(this.format);
                };

                this.isActive = () => {
                    if (!this.textEditorHasFocus) {
                        return false;
                    }

                    let currentNode = window.getSelection().focusNode;
                    if (currentNode) {
                        while (currentNode.id !== EDITOR_ID) {
                            if (currentNode.tagName === 'UL') {
                                return true;
                            }
                            currentNode = currentNode.parentNode;
                        }
                        return false;
                    }
                };
            }
        ]
    })
    .component('nwBtnNumber', {
        template: `<button class="nw-button list-ol" title="{{::$ctrl.translationService.translate('client_ButtonNumericList')}}" ng-class="{ 'nw-button--active': $ctrl.isActive() }" ng-click="::$ctrl.click()"></button>`,
        controller: [
            'translationService',
            '$scope',
            'eventEmitterService',
            function (translationService, $scope, eventEmitterService) {
                this.translationService = translationService;
                this.eventEmitterService = eventEmitterService;
                this.$scope = $scope;
                this.format = 'insertorderedlist';

                this.$onInit = () => {
                    this.eventEmitterService.subscribe('text-editor:focusChanged', (hasFocus) => {
                        this.textEditorHasFocus = hasFocus;
                    });
                };

                this.click = () => {
                    this.$scope.$parent.$ctrl.execCommand(this.format);
                };

                this.isActive = () => {
                    if (!this.textEditorHasFocus) {
                        return false;
                    }

                    let currentNode = window.getSelection().focusNode;
                    if (currentNode) {
                        while (currentNode.id !== EDITOR_ID) {
                            if (currentNode.tagName === 'OL') {
                                return true;
                            }
                            currentNode = currentNode.parentNode;
                        }
                        return false;
                    }
                };
            }
        ]
    })
    .component('nwBtnCodeBlock', {
        template: `<button class="nw-button code-block" title="{{::$ctrl.translationService.translate('client_ButtonCodeBlock')}}" ng-class="{ 'nw-button--active': $ctrl.isActive() }" ng-click="::$ctrl.click()"></button>`,
        controller: [
            'translationService',
            '$scope',
            'eventEmitterService',
            function (translationService, $scope, eventEmitterService) {
                this.translationService = translationService;
                this.eventEmitterService = eventEmitterService;
                this.$scope = $scope;
                this.format = 'formatBlock';

                this.$onInit = () => {
                    this.eventEmitterService.subscribe('text-editor:focusChanged', (hasFocus) => {
                        this.textEditorHasFocus = hasFocus;
                    });
                };

                this.getCodeBlockContext = () => {
                    let selection = window.getSelection();
                    if (!selection || !selection.rangeCount) {
                        return { isInCodeBlock: false, codeElement: null };
                    }

                    let node = selection.getRangeAt(0).startContainer;
                    let isInCodeBlock = false;
                    let codeElement = null;

                    while (node && node.id !== EDITOR_ID) {
                        if (node.tagName === 'CODE') {
                            isInCodeBlock = true;
                            codeElement = node;
                            break;
                        }
                        if (node.tagName === 'PRE') {
                            isInCodeBlock = true;
                            codeElement = node.querySelector('code') || node;
                            break;
                        }
                        node = node.parentNode;
                    }

                    return { isInCodeBlock, codeElement };
                };

                this.click = () => {
                    let selection = window.getSelection();
                    const { isInCodeBlock } = this.getCodeBlockContext();

                    if (isInCodeBlock) {
                        return;
                    }

                    if (selection.toString()) {
                        this.wrapSelectionInCodeBlock(selection);
                    } else {
                        this.insertEmptyCodeBlock();
                    }
                };

                this.wrapSelectionInCodeBlock = (selection) => {
                    if (!selection.rangeCount) return;

                    let range = selection.getRangeAt(0);

                    let fragment = range.cloneContents();

                    let preElement = document.createElement('pre');
                    let codeElement = document.createElement('code');

                    let tempDiv = document.createElement('div');
                    tempDiv.appendChild(fragment);

                    const extractContentWithBreaks = (node) => {
                        let result = document.createDocumentFragment();

                        node.childNodes.forEach((child) => {
                            if (child.nodeType === Node.TEXT_NODE) {
                                if (child.textContent) {
                                    result.appendChild(document.createTextNode(child.textContent));
                                }
                            } else if (child.nodeName === 'BR') {
                                result.appendChild(document.createElement('br'));
                            } else if (child.nodeName === 'DIV' || child.nodeName === 'P') {
                                if (result.childNodes.length > 0) {
                                    result.appendChild(document.createElement('br'));
                                }
                                let innerContent = extractContentWithBreaks(child);
                                result.appendChild(innerContent);
                            } else {
                                let innerContent = extractContentWithBreaks(child);
                                result.appendChild(innerContent);
                            }
                        });

                        return result;
                    };

                    let content = extractContentWithBreaks(tempDiv);
                    codeElement.appendChild(content);
                    preElement.appendChild(codeElement);

                    range.deleteContents();
                    range.insertNode(preElement);

                    let paragraph = document.createElement('p');
                    paragraph.innerHTML = '<br>';
                    if (preElement.nextSibling) {
                        preElement.parentNode.insertBefore(paragraph, preElement.nextSibling);
                    } else {
                        preElement.parentNode.appendChild(paragraph);
                    }

                    selection.removeAllRanges();
                };

                this.insertEmptyCodeBlock = () => {
                    let selection = window.getSelection();
                    if (!selection.rangeCount) return;

                    let range = selection.getRangeAt(0);

                    let preElement = document.createElement('pre');
                    let codeElement = document.createElement('code');
                    codeElement.textContent = '\u200B';
                    preElement.appendChild(codeElement);

                    range.insertNode(preElement);

                    let paragraph = document.createElement('p');
                    paragraph.innerHTML = '<br>';
                    preElement.parentNode.insertBefore(paragraph, preElement.nextSibling);

                    let newRange = document.createRange();
                    newRange.setStart(codeElement, 0);
                    newRange.setEnd(codeElement, 0);
                    selection.removeAllRanges();
                    selection.addRange(newRange);
                };

                this.isActive = () => {
                    if (!this.textEditorHasFocus) {
                        return false;
                    }

                    const { isInCodeBlock } = this.getCodeBlockContext();
                    return isInCodeBlock;
                };
            }
        ]
    });
